import ApplicationIcon from "@mui/icons-material/Assignment";

import ApplicationList from "./ApplicationList";

const resource = {
  list: ApplicationList,
  icon: ApplicationIcon,
  recordRepresentation: (record: any) =>
    `${record.first_name} ${record.last_name}`,
};

export default resource;
